//"use strict" ;
import config from "./modules/config.js";
import * as utils from "./modules/utils.js";
import * as ui from "./modules/ui.js";
import * as events from './modules/events.js';
import './modules/init.js';
import * as validation from './modules/validation.js';
import * as sw from './modules/sw.js';
import * as scrollGuard from "./modules/scroll-guard.js";


let deferredPrompt = null;
if (typeof settingData !== 'undefined') {
  config.pageType = settingData.pagetype;
}
// eventListeners 

//#region helper functions
window.validateLength = utils.validateLength;
window.confirmDelete = utils.confirmDelete;
window.addDesign = utils.addDesign;
window.validateImage = utils.validateImage;
window.hideControls = utils.hideControls;

//#endregion
String.prototype.EntoAr = function () {
  return this.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
};


// eslint-disable-next-line no-unused-vars
function loadFonts() {
  const mainContainer = document.querySelector(".wrapper");
  if (!mainContainer) return;
  if (typeof settingData !== 'undefined') {
    if (["video", "help"].includes(settingData.general.pagetype)) {
      const loader = document.querySelector(".loader-container");
      if (loader) loader.style.display = 'none';
      const imagesContainer = document.querySelector(".images-container");
      // if (imagesContainer) imagesContainer.style.removeProperty('display');
    }
  }
  // stop only now for testing


}
function registerEvents() {
  // load images with loader in lazy loading mode
  if (typeof settingData !== 'undefined') {
    if (["category", "history"].includes(settingData.name) || ["category"].includes(settingData.pagetype)) {

      document.addEventListener('DOMContentLoaded', utils.handleLazyImagesLoader('.img-template'));
    }

  }
  //

}
function main() {
  scrollGuard.install();
  registerEvents();
  // load fonts
  loadFonts();
  // initializeServiceWorker();
  ui.writeAlert("helpcontent");
  // add decoration we disable it on 10-4-2025
  //utils.addImageToContainer('sheep.webp');

  utils.checkFlagDateExists();
  // change the modal message 
  ui.changeModalMessage();
  // disable this line and enable it later
  //sw.initializeServiceWorker();
  // test
  //let deferredPrompt = null;
  //console.log('END OF MAIN...');



}
main();

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  config.deferredPrompt = deferredPrompt;
});

// navigator.serviceWorker.addEventListener('controllerchange', () => {
//   // show modal to ask user
//   // ui.createSubscribeModal("installApp", "ثبت تطبيق صمّم بنفسك", ui.createInstallAppMessage(), utils.fireInstallAppAnswerEvent, utils.fireInstallAppRefuseEvent);
// });


async function installApp() {
  if (!deferredPrompt) {
    // console.log("Install prompt not available");
    // installApp();
    return false;
  }
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  console.log('User choice:', choice);
  deferredPrompt = null;
  return choice.outcome === 'accepted';
}

// Disable this line and enable later
//navigator.serviceWorker.ready.then(() => showInstallToAndroidUsers());

function showInstallToAndroidUsers() {
  if (utils.isPWA())
    return;
  if (!utils.isDesktop()) {
    // show message to install
    ui.createSubscribeModal(config.installAppKey, config.installAppTitle, ui.createInstallAppMessage(), utils.fireInstallAppAnswerEvent, utils.fireInstallAppRefuseEvent)
  }
}


window.addEventListener('appinstalled', () => {
  console.log("PWA installed successfully......!");
});

function resetTries() {
  // get localstorage
  let currentdesign = utils.getLocalStorageValue(`${config.designName}`);
  if (currentdesign != null) {
    // remove the cookie

    utils.setLocalStorageWithFlagExpiry(`${config.designName}`, 2);
    utils.setToLocalStorage(`${config.lastChance}-${config.designName}`, 1, 6);
    window.location.reload();
  }
}
window.resetTries = resetTries;
// events which load when the page is loaded
window.addEventListener('load', () => {
  //console.log("loaded window ...");
  // add any message after 20 seconds
  // setTimeout(function () {
  //   console.log('test..');
  //   utils.loadBootstrapIfNeeded()
  //     .then(() => {
  //       //ui.createSendToFriendModal();
  //       ui.createModalUserMessage(settingData);
  //     })
  //     .catch(error => {
  //       console.error("Error loading Bootstrap:", error);
  //     });

  // }, 3000);

  // show ads in download page
  events.showAdsInDownloadPage();
  events.navigateToStepsDetails();
  events.fireBackToTopEvent();
});






